import styled from 'styled-components';

const ResultWrapper = styled.div``;

ResultWrapper.displayName = 'ResultWrapper';

export default ResultWrapper;
